<template>
    <i v-if="isMaterial"
        ref="icon"
        :class="[
            'icon-material',
            size ? 'icon-material--' + size : '',
            clickable && !disabled ? 'icon-material--clickable' : '',
            isOff ? 'is-off' : '',
            isDisabled || disabled ? 'is-disabled' : '',
            typeClass,
            hoverTypeClass,
            positionClass,
            className ? className : '',
        ]"
        :title="title"
        @click="clickable && !isDisabled ? handleClick($event) : null"
    ><span class="icon-material_icon">{{icon}}</span></i>
    <svg v-else
        ref="icon"
        :class="[
            'icon',
            typeClass,
            size ? 'icon--' + size : '',
            clickable && !disabled ? 'icon--clickable' : '',
            isOff ? 'is-off' : '',
            isDisabled || disabled ? 'is-disabled' : '',
            positionClass,
            className ? className : '',
        ]"
        :title="title"
        @click="clickable && !isDisabled ? handleClick($event) : null"
    >
        <use :xlink:href="`/Scripts/dist/sprite.svg#${this.icon}`" />
    </svg>
</template>

<script>
export default {
    mixins: [],
    props: {
        // size properties
        icon: {
            type: String
        },
        title: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        type: {
            type: String
        },		
        hoverType: {
            type: String
        },
        className: {
            type: String,
            default: ''
        },
        clickable: {
            type: Boolean,
            default: false
        },
        isMaterial: {
            type: Boolean,
            default: false
        },
        inlinePosition: {
            type: String,
            default: ''
        },
        // state properties
        isOff: {
            type: Boolean,
            default: false
        },
        // isDisabled is deprecated. "disabled" (below) should be used instead
        isDisabled: {
            type: Boolean,
            default:false
        },
        disabled: Boolean,
        event: {
            type: [Array, Object],
            default: () => {}
        }
    },
    data () {
        return {};
    },
    computed: {
        base() {
            return this.isMaterial ? 'icon-material' : 'icon';
        },
        positionClass() {
            switch(this.inlinePosition) {
                case 'after':
                    return `${this.base}--inline-after`;
                case 'after-dense':
                    return `${this.base}--inline-after-dense`;
                case 'before':
                    return `${this.base}--inline`;
                case 'before-dense':
                case 'beforeDense':
                    return `${this.base}--inline-before-dense`;
                default:
                    return '';
            }
        },
        typeClass() {
            return this.type ? `${this.base}--${this.type}` : '';
        },
        hoverTypeClass() {
            return this.hoverType ? `${this.base}--hover-${this.hoverType}` : '';
        }
    },
    mounted(){
        if (!this.isMaterial) {
            /* Ensures rspack discovers all SVGs so rspack-plugin-svg-sprite includes them in the sprite */
            import(/* webpackMode: "eager" */ `~/images/icons/${this.icon}.svg`);
        }
    },
    methods: {
        handleClick(event) {
            this.$emit('click', event);
        }
    }
};
</script>